class Controller {
  constructor($injector, $stateParams, Sections) {
    "ngInject";

    this.$stateParams = $stateParams;
    this.Dispatcher = $injector.get("Dispatcher");
    this.RidesTransforms = $injector.get("RidesTransforms");
    this.DispatcherTransforms = $injector.get("DispatcherTransforms");
    this.dispatcherId = this.$stateParams.id;
    this.rideFields = this.RidesTransforms.fields;
    this.scheduleFields = this.DispatcherTransforms.scheduleFields;
    this.sections = Sections.settingsSections;
    this.logFields = this.DispatcherTransforms.logFields;
    this.inQueueSchedulesFields = this.DispatcherTransforms.inQueueSchedulesFields;
  }

  $onInit() {
    this.Dispatcher.get(this.$stateParams.id).$promise.then((response) => {
      this.dispatcher = this.DispatcherTransforms.justify(response);
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/dispatcher/dispatcher.controller.js